import type { GrowLibrary } from "../../api/growth";
import { BackButton } from "../../components/BackButton";
import { Banner } from "../../components/Banner";
import { OptionTile } from "../../components/OptionTile";
import { ScreenHeader } from "../../components/ScreenHeader";

/** The optional Grow Library (Prospectus Part C). Opens after the pathway and never blocks a step. */
export function GrowLibraryScreen({
  library,
  onToggle,
}: {
  library: GrowLibrary;
  onToggle: (key: string) => void;
}) {
  const groups = Array.from(new Set(library.modules.map((m) => m.group)));
  return (
    <div>
      <ScreenHeader
        kicker="Grow Library · optional"
        title="Grow your freelance practice."
        sub="Content for scaling what you've built into something larger. Read what's useful to you, and try the one action in each module."
      />
      {!library.unlocked ? (
        <Banner tone="note">
          The Grow Library opens once you complete the pathway (gig Step 6).
        </Banner>
      ) : null}
      {groups.map((group) => (
        <section key={group} className="mb-5">
          <h3 className="mb-2 text-[17px]">{group}</h3>
          <div className="flex flex-col gap-3">
            {library.modules
              .filter((m) => m.group === group)
              .map((module) => (
                <div
                  key={module.key}
                  className="rounded-[var(--radius-card)] border border-border bg-surface p-4"
                >
                  <div className="text-[11px] font-bold uppercase tracking-[0.1em] text-kicker">
                    {module.source}
                  </div>
                  <h4 className="mt-1 text-[16px] font-bold">{module.title}</h4>
                  <p className="m-0 mt-1 text-[14px] text-text-muted">{module.summary}</p>
                  <ul className="m-0 mt-2 pl-5 text-[13.5px]">
                    {module.topics.map((topic) => (
                      <li key={topic}>{topic}</li>
                    ))}
                  </ul>
                  <p className="mt-2 text-[13.5px]">
                    <b>Try this:</b> {module.action}
                  </p>
                  <OptionTile
                    selected={module.done}
                    disabled={!library.unlocked}
                    title="I've read this and tried the action"
                    onToggle={() => onToggle(module.key)}
                  />
                </div>
              ))}
          </div>
        </section>
      ))}
      <BackButton to="/hub" label="Back to my steps" />
    </div>
  );
}
